<script>
    import {Gtag} from '../../mixins/ga'

    export default {
        mixins: [Gtag],
        data() {
            return {
                reservation: null,
                course: null
            }
        },
        computed: {
            lessonDateIsPast() {
                if (this.course && this.course.lesson_date_time) {
                    let date = moment(this.course.lesson_date_time)
                    return date.isBefore(moment())
                }
                return false
            },
            lessonDateIsPastOrFuture() {
                if (this.course && this.course.lesson_date_time) {
                    let date = moment(this.course.lesson_date_time)
                    return date.isBefore(moment()) || date.isAfter(moment())
                }
                return false
            },
        },
        mounted() {
            this.$bus.$on('update-reservation', ({reservation, course}) => {
                this.$set(this, 'reservation', reservation)
                this.$set(this, 'course', course)
            })
        },
        methods: {
            openContactForm() {
                this.sendGaEvent(
                    'Contatta-societa',
                    'Corsi',
                    '#contatta-societa-sticky'
                )

                if (this.lessonDateIsPastOrFuture) {
                    if (this.reservation.reservation_date) {
                        gtag('event', 'Prenotazionestart', {
                            'event_category': 'Corsi',
                            'event_label': '#contatta-societa-scaduto-sticky'
                        });
                    } else {
                        gtag('event', 'Prenotazionestart', {
                            'event_category': 'Corsi',
                            'event_label': '#contatta-societa-scaduto-sticky-senza'
                        });
                    }
                }

                var $modal = $("#reservationContactFormModal")

                this.$bus.$emit('update-reservation-contact-form', {
                    message: `Buongiorno,\nè possibile prenotare una prova conoscitiva?`
                })

                $modal.modal('show');
                return
            },
            sendGtag() {
                if (this.reservation.reservation_date) {
                    gtag('event', 'Prenotazionestart', {
                        'event_category': 'Corsi',
                        'event_label': '#button-prenota-ingresso-sticky'
                    });
                } else {
                    gtag('event', 'Prenotazionestart', {
                        'event_category': 'Corsi',
                        'event_label': '#button-prenota-ingresso-sticky-senza'
                    });
                }
            },
            onSubmitTrial() {
                this.sendGaEvent(
                    'Prenotazionestart', 
                    'Corsi',
                    '#prenota-prova-sticky'
                )

                this.$bus.$emit('reservation-trial', {
                    value: 1,
                    type: 'lessons',
                    key: 'modal',
                })
            },
            onSubmitEntry() {
                this.sendGaEvent(
                    'Prenotazionestart',
                    'Corsi',
                    '##prenota-ingresso-sticky'
                )
                this.$bus.$emit('reservation-trial', {
                    value: 0,
                    type: 'entries',
                    key: 'modal'
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseStickyNavbar.vue